import { render, staticRenderFns } from "./QuestionsMultiAnswersComponent.vue?vue&type=template&id=42cd680a&scoped=true&"
import script from "./QuestionsMultiAnswersComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionsMultiAnswersComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsMultiAnswersComponent.vue?vue&type=style&index=0&id=42cd680a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd680a",
  null
  
)

export default component.exports